<template>
  <div class="teacher-info" :class="[maskClassName, hoverName, highClass, hkColorClassName, { 'hk-teacher-info': isHKTeacherList }]" :index="index" @mouseenter="handleMouseenter" @mouseleave="handleMouseleave">
    <div v-show="isHKTeacherList && hover" class="hk-hover-mask" />
    <div class="avatar">
      <div class="mask">
        <div
          class="simple-logo"
          :style="isHKTeacherList ? null : { backgroundImage: `url(${$t('common.logo.simpleWhite')})` }"
        >
          <img
            v-if="isHKTeacherList && hover"
            v-lazy-load :data-src="$t('common.logo.simpleWhite')"
            alt=""
          >
        </div>
      </div>
      <div class="avatar-image">
        <!-- 固定图片尺寸，避免图片加载时导致CLS -->
        <img
          :data-not-lazy="!avatarLazyLoad"
          v-lazy-load :data-src="`${teacher.avatar}?im=Resize=(${isHKTeacherList ? '568,568' : '508,508'})`"
          :alt="teacher.name"
          class="teacher-avatar"
          :width="isHKTeacherList ? 284 : 254"
          :height="isHKTeacherList ? 284 : 254"
        >
      </div>
      <!-- 港分不显示 -->
      <div v-show="hover && !isHKTeacherList" class="guide">
        <div class="name font-bold">
          {{ teacher.name }}
        </div>
        <div class="icon">
          <i class="iconfont icon-next" />
        </div>
      </div>
    </div>
    <div v-show="!hover" class="intro">
      <div v-if="isHKTeacherList" style="height: 17px;" />
      <div class="name font-bold text-overflow-ellipsis">
        {{ teacher.name }}
      </div>
      <div class="education font-medium text-overflow-ellipsis-2">
        {{ teacher.education }}
      </div>
    </div>
    <div class="teacher-hover-content">
      <div v-if="isHKTeacherList && hover" class="hk-hover-name font-bold">
        {{ teacher.name }}
      </div>
      <div class="hk-scroll-area">
        <div v-show="hover && !showExperience" class="tags hk-scroll-content" @scroll="handleHoverContentScroll">
          <div v-if="teacher.highlightList" class="tag-wrapper">
            <div
              v-for="(tag, tagIndex) in teacher.highlightList.slice(0, isHKTeacherList ? teacher.highlightList.length : 3)"
              :key="tagIndex"
              class="tag-item"
              :class="{ 'text-overflow-ellipsis': !isHKTeacherList }"
              :title="tag"
            >
              # {{ tag }}
            </div>
          </div>
        </div>
        <div v-show="hover && showExperience" class="experience hk-scroll-content" :class="{ 'text-overflow-ellipsis-6': !isHKTeacherList }" @scroll="handleHoverContentScroll">
          {{ teacher.experience }}
        </div>
        <div v-if="isHKTeacherList && hover && hkHoverScrollable && !hkHoverAtTop" class="hk-scroll-mask hk-scroll-mask-top" />
        <div v-if="isHKTeacherList && hover && hkHoverScrollable && !hkHoverAtBottom" class="hk-scroll-mask hk-scroll-mask-bottom" />
      </div>
    </div>
    <div v-if="isHKTeacherList && hover" class="hk-view-detail font-medium">
      <span>{{ $t('teacher.viewTeacherDetails') }}</span>
      <i class="iconfont icon-next" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    index: {
      default: 1,
      type: Number,
    },
    teacher: {
      default: () => ({}),
      type: Object,
    },
    showExperience: {
      default: false,
      type: Boolean,
    },
    avatarLazyLoad: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      hover: false,
      hkHoverScrollable: false,
      hkHoverAtTop: true,
      hkHoverAtBottom: false,
    }
  },
  computed: {
    isHKTeacherList() {
      return this.$store.state.locale === 'hk' && this.$route.name === 'teachers'
    },
    maskClassName() {
      let { index } = this
      if (this.index > 5) {
        index = this.index % 5
      }
      if (index === 0) {
        index = 5
      }
      return `mask-${index}`
    },
    hkColorClassName() {
      if (!this.isHKTeacherList) {
        return ''
      }
      return `hk-color-${((this.index - 1) % 4) + 1}`
    },
    hoverName() {
      return this.hover ? 'hover' : ''
    },
    highClass() {
      return this.showExperience ? 'high' : ''
    },
  },
  mounted() {
    this.teacherCardShow()
  },
  methods: {
    teacherCardShow() {
      const currRoute = this.$route.name
      if (currRoute !== 'teachers') {
        return
      }
      this.Sensors.track('teacher_card_show', {
        content_teacher: this.teacher.name,
        teacher_card_type: '小卡',
        previous_source: 'our teachers',
      })
    },
    handleMouseenter() {
      this.hover = true
      this.hkHoverScrollable = false
      this.hkHoverAtTop = true
      this.hkHoverAtBottom = false
      this.$nextTick(() => {
        const scrollElement = Array.from(this.$el.querySelectorAll('.hk-scroll-content'))
          .find((element) => element.offsetParent !== null)
        if (scrollElement) {
          // Every hover starts at the beginning so the lower fade is visible by default.
          scrollElement.scrollTop = 0
          this.updateHoverContentScroll(scrollElement)
        }
      })
    },
    handleMouseleave() {
      this.hover = false
      this.hkHoverScrollable = false
      this.hkHoverAtTop = true
      this.hkHoverAtBottom = false
    },
    handleHoverContentScroll(event) {
      this.updateHoverContentScroll(event.currentTarget)
    },
    updateHoverContentScroll(scrollElement) {
      const maxScrollTop = Math.max(scrollElement.scrollHeight - scrollElement.clientHeight, 0)
      this.hkHoverScrollable = maxScrollTop > 1
      this.hkHoverAtTop = scrollElement.scrollTop <= 1
      this.hkHoverAtBottom = scrollElement.scrollTop >= maxScrollTop - 1
    },
  },
}

</script>
<style lang="scss" scoped>
.teacher-info {
  position: relative;
  height: 374px;
  padding: 15px;
  border-radius: 12px;
  width: 284px;

  &.high {
    height: 410px;
  }

  .hk-hover-mask {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    width: 284px;
    height: 374px;
    border-radius: 12px;
    background-color: inherit;
  }

  &::after {
    content: " ";
    position: absolute;
    left: 15px;
    top: 15px;
    z-index: 1;
    width: 10px;
    height: 10px;
  }

  &::before {
    content: " ";
    position: absolute;
    right: 15px;
    top: 15px;
    z-index: 1;
    width: 10px;
    height: 10px;
  }

  .avatar {
    position: relative;
    width: 254px;
    height: 254px;
    border-radius: 10px;
    overflow: hidden;
    background-color: #fff;

    .avatar-image {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
    }

    .teacher-avatar {
      width: 251px;
      height: 251px;
      object-fit: cover;
    }
  }

  .mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 254px;
    height: 254px;
    background-size: cover;

    .simple-logo {
      position: absolute;
      left: 10px;
      top: 10px;
      width: 22px;
      height: 22px;

      img {
        display: block;
        // width: calc(100% - 3px);
        // height: calc(100% - 3px);
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  &.hk-teacher-info.hover {
    &.hk-color-1 {
      background-color: #3370ff;

      --hk-mask-color: #3370ff;

      &::after,
      &::before {
        background: #3370ff;
      }
    }

    &.hk-color-2 {
      background-color: #ffb07b;

      --hk-mask-color: #ffb07b;

      &::after,
      &::before {
        background: #ffb07b;
      }
    }

    &.hk-color-3 {
      background-color: #00cd83;

      --hk-mask-color: #00cd83;

      &::after,
      &::before {
        background: #00cd83;
      }
    }

    &.hk-color-4 {
      background-color: #ff9f0a;

      --hk-mask-color: #ff9f0a;

      &::after,
      &::before {
        background: #ff9f0a;
      }
    }

    &.high {
      height: 374px;
    }

    .avatar {
      z-index: 1;
      background-color: inherit;
    }

    .avatar-image {
      opacity: 0.02;
      filter: blur(4px);
    }

    .guide {
      z-index: 2;
    }

    .mask .simple-logo {
      left: 15px;
      top: 20px;
      width: 22px;
      height: 22px;
    }

    .teacher-hover-content,
    .hk-view-detail {
      position: absolute;
      z-index: 2;
      left: 15px;
      color: #fff;
      text-align: left;
      font-size: 20px;
      font-weight: 600;
    }

    .teacher-hover-content {
      right: 15px;
      bottom: 73px;
    }

    .hk-hover-name {
      margin-bottom: 12px;
      font-size: 20px;
      line-height: 28px;
    }

    .tags,
    .experience {
      position: static;
      width: auto;
      height: auto;
      max-height: 166px;
      padding-right: 6px;
      margin-top: 0;
      overflow-x: hidden;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      font-size: 16px;
      line-height: 24px;
      // Fade masks indicate overflowing content without exposing a scrollbar.
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
        width: 0;
      }
    }

    .hk-scroll-area {
      position: relative;
    }

    .hk-scroll-mask {
      position: absolute;
      right: 6px;
      left: 0;
      z-index: 1;
      height: 10px;
      pointer-events: none;
    }

    .hk-scroll-mask-top {
      top: 0;
      background: linear-gradient(to bottom, var(--hk-mask-color) 0%, rgba(0, 0, 0, 0) 100%);
    }

    .hk-scroll-mask-bottom {
      bottom: 0;
      background: linear-gradient(to top, var(--hk-mask-color) 0%, rgba(0, 0, 0, 0) 100%);
    }

    .tags {
      display: block;

      .tag-item {
        width: 100%;
        height: auto;
        min-height: 24px;
        line-height: 24px;
        text-align: left;
        white-space: normal;
        word-break: break-word;

        & + .tag-item {
          margin-top: 8px;
        }
      }
    }

    .experience {
      white-space: pre-wrap;
      word-break: break-word;
    }

    .hk-view-detail {
      display: flex;
      align-items: center;
      justify-content: space-between;
      right: 15px;
      bottom: 15px;
      font-size: 16px;
      color: #222;
      background: #fff;
      height: 40px;
      border-radius: 27px;
      padding: 8px 15px;

      .icon-next {
        font-size: 14px;
      }
    }
  }

  &.mask-1 {
    &.hover {
      background-color: #ffb07b;

      &::after,
      &::before {
        background: #ffb07b;
      }
    }

    .mask {
      background-image: url("~assets/images/teacher/mask-pink.svg");
    }
  }

  &.mask-2 {
    &.hover {
      background-color: #02ca8a;

      &::after,
      &::before {
        background: #02ca8a;
      }
    }

    .mask {
      background-image: url("~assets/images/teacher/mask-green.svg");
    }
  }

  &.mask-3 {
    &.hover {
      background-color: #3370ff;

      &::after,
      &::before {
        background: #3370ff;
      }
    }

    .mask {
      background-image: url("~assets/images/teacher/mask-blue.svg");
    }
  }

  &.mask-4 {
    &.hover {
      background-color: #ffaa0a;

      &::after,
      &::before {
        background: #ffaa0a;
      }
    }

    .mask {
      background-image: url("~assets/images/teacher/mask-yellow.svg");
    }
  }

  &.mask-5 {
    &.hover {
      background-color: #6f48fa;

      &::after,
      &::before {
        background: #6f48fa;
      }
    }

    .mask {
      background-image: url("~assets/images/teacher/mask-purple.svg");
    }
  }

  &.hk-teacher-info {
    &::after {
      // width: 10px;
      // height: 10px;
      width: auto;
      height: auto;
    }

    .avatar {
      width: 284px;
      height: 284px;
      margin: -15px;
      border-radius: 12px;

      .teacher-avatar {
        width: 284px;
        height: 284px;
      }
    }

    .mask {
      z-index: 1;
      width: 284px;
      height: 284px;
      background-image: none;
    }

    &:not(.hover) {
      .simple-logo {
        left: 15px;
        top: 20px;
        width: 22px;
        height: 22px;
        background-image: url("~assets/images/teacher/hk-teacher-logo.svg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
      }
    }
  }

  .intro {
    margin-top: 20px;

    .name {
      height: 24px;
      line-height: 24px;
      font-size: 20px;
      font-weight: bold;
      color: var(--txt-color-lv1);
    }

    .education {
      height: 44px;
      line-height: 22px;
      margin-top: 5px;
      font-weight: 500;
      font-size: 16px;
      color: var(--txt-color-lv1);
    }
  }

  .guide {
    position: absolute;
    width: 100%;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    height: 42px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    padding: 0 8px;

    .name {
      line-height: 42px;
      font-size: 20px;
      color: #fff;
    }

    .icon {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 6px;
      width: 50px;
      height: 30px;
      background: #fff;
      box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
      border-radius: 17px;
    }
  }

  .tags {
    display: flex;
    align-items: center;
    height: 90px;
    margin-top: 8px;

    .tag-wrapper {
      width: 100%;
    }

    .tag-item {
      width: 254px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #fff;
      font-weight: bold;
    }
  }

  .experience {
    margin-top: 10px;
    height: 114px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    line-height: 19px;
  }
}
</style>
